import React, { useContext } from 'react';

import { context } from '../../../../components/Theme/Context';

function ThemedGradient() {
  const theme = useContext(context);

  return (
    <div
      className="tw:absolute tw:z-0 tw:left-0 tw:top-0"
      style={
        theme.useCustomTheme
          ? {
              backgroundColor: theme.colors.background,
              width: '100%',
              height: '100%',
            }
          : {
              background: `radial-gradient(circle, ${theme.colors.background} 0%, var(--black-pearl) 50%)`,
              width: '200%',
              height: '200%',
            }
      }
    ></div>
  );
}

export default ThemedGradient;
